import { getOptionValue } from './get-option-value'

export const SelectAllOptionValue = '__DHL_UI_AUTOCOMPLETE_SELECT_ALL__'

/**
 * even when Value is a string, we can use an object here
 */

export type SelectAllOption = {
  value: typeof SelectAllOptionValue
  label: string
}

export const isSelectAllOption = <Value>(option: Value | SelectAllOption): option is SelectAllOption =>
  getOptionValue(option) === SelectAllOptionValue
